import { Field, Status } from '../types/GameTypes';
import './Box.css';

type BoxProps = {
  mode: Status
  field: Field
  mainText: string 
  subText?: string
  onClick?: (field: Field) => void;
}

export const Box: React.FC<BoxProps> = ({mode, field, mainText, subText, onClick}: BoxProps) => {

  const clicked = () => {
    onClick && onClick(field);
  }

  return (
    <div className={`Box ${mode}`} onClick={clicked}>
      { mode !== "Empty" &&
        <>
          <h4>{mainText}</h4>
          {subText && <h5>{subText}</h5>}
        </>
      }
    </div>
  )
}

